import React from "react";
import {
  Col,
  Row,
  Container,
  Card,
  Button,
  Image,
  Form,
} from "react-bootstrap";
import "./index.css";
import banner from "./img/logo.jpeg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faSave,
  faFolderOpen,
  faSearch,
} from "@fortawesome/free-solid-svg-icons";

import Request from "./request";
import { AppContext } from "./context";
import { withRouter } from "./withRouter";

class App extends React.Component {
  static contextType = AppContext;

  constructor(props) {
    super(props);
    this.state = {
      denunciaId: "",
      denunciaStatus: null,
      errorMessage: "",
      showSearchInput: false,
      showDenunciaPage: false,
    };
  }


  handleInputChange = (event) => {
    this.setState({ denunciaId: event.target.value });
  };

  handleSearch = () => {
    const { denunciaId } = this.state;
    if (!denunciaId || isNaN(denunciaId)) {
      this.setState({
        errorMessage: "O valor inserido não é válido.",
        denunciaStatus: null,
      });
      return;
    }
    
    const errorHandler = (err) =>
      this.setState({
        errorMessage: "Denúncia não existente.",
        denunciaStatus: null,
      });
      
    Request(
      'GET', this.context.config.BACKEND_URL + "/Denuncia/consultaExterna/" + denunciaId
    )
      .send()
      .then((options) => {
        this.setState(() => ({ denunciaStatus: options.body, errorMessage: "" }));
      })
      .catch(errorHandler);
  };

  toggleSearchInput = () => {
    this.setState((prevState) => ({
      showSearchInput: !prevState.showSearchInput,
    }));
  };

  handleRegisterDenuncia = () => {
    this.props.history("/registrar");
  };
  

  render() {
    const { denunciaStatus, errorMessage, showSearchInput } = this.state;
    return (
      <Container fluid className="container-fluid">
        <div className="content">
          <Image src={banner} className="rounded-image" />
          <Row className="white-background">
            <Col lg={12} className="col-div">
              <Card className="card">
                <Card.Title className="card-title">
                  <strong>
                    {" "}
                    Seja bem vindo à central de denúncias, o que você deseja
                    fazer?
                  </strong>
                </Card.Title>
                <Card.Body className="div-principal">
                  <Card.Body className="guardar-div">
                    {" "}
                    {!showSearchInput && (
                      <Button
                        variant="primary"
                        onClick={this.toggleSearchInput}
                        className="button"
                      >
                        <FontAwesomeIcon icon={faFolderOpen} />
                        &nbsp; <span>Consultar Denúncias</span>
                      </Button>
                    )}
                    {showSearchInput && (
                      <Card.Body className="ocultDiv ">
                        <Form.Group className="input mb-0">
                          <Form.Control
                            type="text"
                            placeholder="Número da Denúncia"
                            value={this.state.denunciaId}
                            onChange={this.handleInputChange}
                            className="form"
                          />
                        </Form.Group>
                        <Button
                          variant="primary"
                          onClick={this.handleSearch}
                          className="search-button"
                        >
                          <FontAwesomeIcon icon={faSearch} />
                        </Button>
                      </Card.Body>
                    )}
                    {denunciaStatus && (
                      <Card.Body className="custom-card">
                        <p className="denuncia-info">
                          Número da Denúncia: {this.state.denunciaId}
                        </p>
                        <p className="denuncia-info">
                          Status da Denúncia: {this.state.denunciaStatus.status}
                        </p>
                      </Card.Body>
                    )}
                    {errorMessage && (
                      <Card.Body>
                        <p>{errorMessage}</p>
                      </Card.Body>
                    )}
                  </Card.Body>
                  <Button
                    variant="primary"
                    onClick={this.handleRegisterDenuncia}
                    className="button"
                  >
                    <FontAwesomeIcon icon={faSave} />
                    &nbsp; <span>Registrar Denúncias</span>
                  </Button>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </div>
      </Container>
    );
  }
}

export default withRouter(App);
